import { BaseModel } from "sjs-base-model";

export default class PlatformModel extends BaseModel {
  public readonly name: string = "";
  public readonly slug: string = "";

  constructor(data: Partial<PlatformModel>) {
    super();

    this.update(data);
  }
}
